export default {
	registration: 'Зарегистрироваться',
	register: 'Зарегистрироваться',
	pages: {
		home: 'Главная',
	},
	RegistrationRequired: 'Регистрация обязательна',
	LimitedAccess: 'Количество мест ограничено',
	AddCal: 'Добавить в календарь',
	download: 'Скачать',
	ThankUfor: 'Спасибо',
	startAt: 'Трансляция начнется через:',
	startOn: 'Начнется',
	start: 'Начало',
	at: 'в',
	linkConnect: 'Ссылка для подключения:',
	linkSend: 'Cсылка на трансляцию отправлена на email, указанный при регистрации',
	dontFind: 'Если вы не получили письмо, пожалуйста, проверьте папку «СПАМ»',
	consultantsContact: 'Наши консультанты свяжутся с вами для уточнения деталей.',
	watchOnline: 'Смотреть онлайн',
	watchVideo: 'Смотреть видео',
	watchNow: 'Смотреть',
	enterName: 'Пожалуйста, введите имя для чата',
	logIn: 'Авторизоваться',
	authentication: 'Авторизация',
	signInUp: 'Войти через ЛК',
	loginSilent: 'Войти без авторизации',
	yes: 'Да',
	no: 'Нет',
	typing: 'печатает...',
	message: 'Сообщение...',
	name: 'Ваше имя',
	send: 'Отправить',
	sending: 'Отправляется...',
	sendAgain: 'Отправить повторно',
	Russia: 'Россия',
	India: 'Индия',
	China: 'Китай',
	Europe: 'Европа',
	Singapore: 'Сингапур',
	Brazil: 'Бразилия',
	Africa: 'Африка',
	CongressHall: 'Конгресс-холл',
	ChatWithAdvisor: 'Чат с консультантом',
	CallBack: 'Обратный звонок',
	more: 'Подробнее',
	read: 'Читать далее',
	watch: 'Смотреть',
	listen: 'Слушать',
	allMatrials: 'Все материалы',
	siteSearch: 'Поиск по сайту',
	search: 'Найти',
	example: 'Например, как поступить на MBA?',
	professors: 'Профессора',
	biography: 'Биография',
	contacts: 'Контакты',
	education: 'Образование',
	events: 'Мероприятия',
	programmes: 'Программы',
	publications: 'Публикации',
	research: 'Исследования',
	content: 'Контент',
	disciplines: 'Дисциплины',
	photoVideo: 'Фото, видео, медиа',
	mediaContent: 'Медиаконтент',
	request: 'Запросить',
	requestСonsultation: 'Запросить консультацию',
	step: 'Шаг',
	apply: 'Подать заявку',
	moreEvents: 'Все события',
	moreNews: 'Все новости',
	news: 'Новости',
	suitableEvent: 'Не увидели подходящего мероприятия?',
	fullInfo: 'Чтобы получить всю информацию об интересующем вас мероприятии, свяжитесь с нашим консультантом',
	show: 'Еще',
	hide: 'Скрыть',
	views: 'просмотров',
	allPhoto: 'Все фото',
	price: 'Стоимость:',
	addInvoice: 'Добавить в счет',
	author: 'Автор',
	authors: 'Авторы',
	contentSource: 'Источник',
	printCV: 'Печать CV',
	addToLibrary: 'Добавить в библиотеку',
	delToLibrary: 'Удалить из библиотеки',
	qa: 'Вопросы и ответы',
	article: 'Статья',
	keyPublications: 'Ключевые публикации и упоминания',
	offerEnds: 'Скидка до',
	giveNow: 'Поддержать Школу',
	give: 'Поддержать',
	hello: 'Привет',
	skolkovo_shop: 'Skolkovo Shop',
	aboutSchool: 'О Школе',
	OrganisationalStructure: 'Управление',
	Management: 'Руководство школы',
	Team: 'Команда',
	BoardofDirectors: 'Совет директоров',
	InternationalAdvisoryBoard: 'Международный попечительский совет',
	InternationalAcademicCouncil: 'Международный академический совет',
	AcademicCommittee: 'Ученый совет',
	history: 'Наша история',
	accreditations: 'Аккредитация и партнерства',
	campus: 'Кампус',
	sustainability: 'Устойчивое развитие',
	codeofEthics: 'Кодекс этики',
	logoSkolkvo: '/frontimg/logo_skolkovo_rus_transparent.png',
	academicDegree: 'Учёное звание:',
	readsInPrograms: 'Читает в программах:',
	schoolAdress: '143026, Московская область, г.о. Одинцовский, деревня Сколково, улица Новая, дом 100',
	contactConsultant: 'Связаться с консультантом',
	support: 'Хочу поддержать',
	share: 'Поделиться в соцсетях',
	shareSub: 'Поделитесь проектом в сети',
	gratitude: 'Мы благодарны за вашу поддержку!',
	thankYouSection: 'Ваше имя появится в разделе «Мы благодарим» на сайте, если вы не поставили "галочку" в форме пожертвования',
	email: 'Сообщите нам, если вы хотели бы изменить свое решение:',
	authEmail: 'E-mail',
	sincerely: 'С уважением',
	team: 'Команда Школы управления СКОЛКОВО',
	campaignInformation: 'Мы будем регулярно информировать Вас о ходе кампании, объёме собранных средств, реализации обозначенных проектов.',
	people: 'человек',
	beenSupported: 'Нас уже поддержали',
	registrationOn: 'Регистрация на',
	registrationClosed: 'Регистрация закрыта',
	alreadySubmitted: 'Вы уже подали заявку ранее',
	notificationsNote: 'Если вы хотите получать уведомления о мероприятиях на смежную тему, оставьте, пожалуйста, свои данные.',
	supportNote: 'Мировая практика показывает, что развитие бизнес-школ невозможно без регулярной поддержки ее выпускников и партнеров. Культура пожертвования — наша миссия для обеспечения устойчивости и взаимоподдержки в предпринимательском сообществе. Оставляя свои контактные данные, Вы даете нам возможность поблагодарить Вас персонально.',
	selectAll: 'Выбрать все',
	fillNameMessage: 'Пожалуйста, укажите ваше имя',
	fillLastNameMessage: 'Пожалуйста, укажите вашу фамилию',
	fillSecondNameMessage: 'Пожалуйста, укажите ваше отчество',
	fillCompanyNameMessage: 'Пожалуйста, укажите вашу компанию/проект',
	fillSchoolNameMessage: 'Пожалуйста, укажите вашу школу',
	fillJobMessage: 'Пожалуйста, укажите вашу должность',
	fillProgramsMessage: 'Пожалуйста, выберите продукт',
	jobPlaceholder: 'Должность',
	classPlaceholder: 'Класс',
	fillClassPlaceholder: 'Пожалуйста, укажите ваш класс',
	fillPhoneMessage: 'Пожалуйста, укажите ваш номер телефона',
	fillEmailMessage: 'Пожалуйста, укажите ваш email',
	validEmailMessage: 'Пожалуйста, укажите валидный email',
	cityPlaceholder: 'Город',
	fillCityMessage: 'Пожалуйста, укажите ваш город',
	fillUniversityMessage: 'Пожалуйста, укажите ваш университет',
	universityPlaceholder: 'Университет',
	fillBirthdayMessage: 'Пожалуйста, укажите ваш  день рождения',
	fillParticipationFormatMessage: 'Пожалуйста, укажите формат участия',
	birthdayPlaceholder: 'Дата вашего рождения дд.мм.гггг',
	areYouStudent: 'Вы студент / выпускник?',
	commentPlaceholder: 'Какой вопрос вы бы хотели задать спикерам?',
	fillCommentMessage: 'Пожалуйста, укажите комментарий',
	commentMaxLength: 'Длина сообщения не должна превышать 300 символов',
	countrySelectorError: 'Выберите страну',
	phoneNumberLabel: 'Номер телефона',
	exampleEvent: 'Пример:',
	agreement: 'согласие на обработку моих персональных данных',
	agreements: 'Соглашения',
	agreementsForEmail: 'Соглашения для пользователя ',
	isAgreesToMarketingEmails: 'Соглашаюсь получать информацию о специальных предложениях, анонсах мероприятий и программ Школы и партнеров',
	isAgreesToMarketingEmailsLong: 'Поставьте галочку, если вы хотите получать маркетинговые рассылки',
	isAgreesToCanViewAlumniDirectory: 'Соглашаюсь на отображение в Директории выпускников и c положением о Директории выпускников',
	sendingFormIgive: 'Отправляя форму, я даю',
	and: 'и',
	acceptTheTermsOThePublicOfferAgreement: 'принимаю условия договора публичной оферты',
	agreementRequired: 'Необходимо принять условия',
	supportEvent: 'Поддержать',
	namePlaceholder: 'Имя',
	lastNamePlaceholder: 'Фамилия',
	secondNamePlaceholder: 'Отчество',
	companyPlaceholder: 'Компания',
	englishLevel: 'Уровень английского',
	participationFormat: 'Формат участия',
	certificateNumber: 'Номер сертификата',
	certificateNumberPlaceholder: 'Номер сертификата прививки',
	fillCertificateNumberMessage: 'Пожалуйста, заполните номер сертификата',
	otherSum: 'Ваша сумма',
	totalAmount: 'Итоговая сумма',
	paymentMethod: 'Способ оплаты',
	choosePaymentMethod: 'Выберите способ оплаты',
	choosePaymentMethodErr: 'Пожалуйста, выберите способ оплаты',
	englishLevelErr: 'Пожалуйста, укажите уровень английского',
	bankCard: 'Банковская карта',
	uMoney: 'ЮMoney',
	sberbank: 'Сбербанк Онлайн',
	tinkoff: 'Тинькофф',
	qiwi: 'Qiwi Кошелёк',
	cash: 'Наличные',
	alfa: 'Альфа-Клик',
	submitAgreement: 'Отправляя форму, я даю',
	submitAgreementShort: 'Отправляя форму, я',
	personalDataProcessing: 'согласие на обработку моих персональных данных',
	donationOffer: 'принимаю условия оферты о пожертвовании',
	acceptTerms: 'принимаю условия договора публичной оферты для',
	acceptLoyalty: 'соглашаюсь стать участником Программы лояльности Школы и принимаю',
	acceptLoyaltyB2B: 'соглашаюсь стать участником Программы лояльности Школы для корпоративных клиентов и принимаю',
	agreementLoyalty: 'правила участия',
	installment: 'Период и ставка рассрочки',
	chooseOneProgram: 'Пожалуйста, выберите хотя бы одну программу',
	specifySum: 'Пожалуйста, укажите сумму',
	specifySumFromTo: 'Пожалуйста, укажите сумму от 500 до 600 000 рублей',
	universityFaculty: 'Пожалуйста, укажите ваш факультет',
	openMenu: 'Открыть меню',
	searchVar: 'Поиск',
	impaired: 'Версия для слабовидящих',
	login: 'Логин',
	alumni: 'Выпускники',
	staff: 'Сотрудники',
	students: 'Студенты',
	createAccount: 'Создать учетную запись',
	signIn: 'Войти',
	signInLk: 'Войти в личный кабинет',
	password: 'Пароль',
	resetPassword: 'Cбросить пароль',
	forgotPassword: 'Забыли пароль?',
	incorrectData: 'Введённые данные неверны',
	loginWith: 'Войти с помощью',
	loginWithPassword: 'Вход по паролю',
	loginWithCode: 'Вход по коду',
	code: 'Код',
	auth: 'Авторизация',
	person: 'Физическое лицо',
	corporate: 'Корпоративный клиент',
	createAccountPerson: 'Создать учетную запись для физического лица',
	emailField: 'Email',
	confirmPassword: 'Подтвердите пароль',
	agreeWith: 'Соглашаюсь с',
	agreeWithLoyalty: 'Cоглашаюсь стать участником Программы лояльности Школы и принимаю',
	loyaltyLegal: 'правила участия',
	bonusBalance: 'Бонусный баланс',
	priceWithFullCharge: 'Стоимость с учетом списания баллов лояльности',
	xPointsWillBeCredited: 'Будет начислено {points} баллов лояльности',
	xPointsWillBeCreditedAfterRegistration: 'Будет начислено {points} баллов на бонусный счет после регистрации в Программе лояльности Школы',
	birthday: 'Дата рождения',
	personalData: 'условиями обработки и хранения персональных данных',
	createAccountCorporate: 'Создать учетную запись для корпоративного клиента',
	adminName: 'Имя администратора',
	adminLastName: 'Фамилия администратора',
	corporateEmail: 'Email (укажите корпоративную почту для уведомлений)',
	authDescription: 'Создайте аккаунт для удобной регистрации на события, оперативной поддержки и управления личной программой лояльности.',
	academic: 'Академический блок',
	media: 'Медиа',
	historyVar: 'История',
	management: 'Управление',
	accreditationsAndPartnerships: 'Аккредитация и партнерства',
	helpfulInformation: 'Полезная информация',
	educationalPrograms: 'Образовательные программы',
	allPrograms: 'Все программы',
	eventAnnounces: 'Анонсы событий',
	allEvents: 'Все события',
	intellectualProperty: 'Интеллектуальная собственность',
	copyright: 'Московская школа управления СКОЛКОВО. Все права защищены.',
	InformationAboutOrganization: 'Сведения об образовательной организации',
	cancel: 'Отмена',
	pleaseSpeak: 'Пожалуйста, говорите...',
	skolkovoShop: 'Skolkovo Shop',
	supportSchool: 'Поддержать Школу',
	welcome: 'Добро пожаловать',
	overview: 'Обзор',
	profile: 'Профиль',
	activities: 'Активности',
	loyaltyProgram: 'Программа лояльности',
	admissions: 'Адмиссии',
	myLibrary: 'Библиотека',
	registered: 'Регистрации',
	payment: 'Оплаты',
	purchase: 'История заказов',
	activate: 'Активация аккаунта',
	resend: 'Выслать письмо повторно',
	tooMAnyEmails: 'Слишком много писем было отправлено на',
	tryAgainTime: 'Пожалуйста попробуйте снова через',
	activationEmail: 'Письмо активации выслано повторно',
	logout: 'Выйти',
	latestEvents: 'Уведомления',
	basicDetails: 'Основная информация',
	fillOut: 'Пожалуйста, заполните поле',
	save: 'Сохранить',
	invalidInputData: 'Введённые данные неверны',
	additionalDetails: 'Дополнительная информация',
	documents: 'Документы',
	settings: 'Настройки',
	webinar: 'Вебинар',
	workshop: 'Практикум',
	readMore: 'Подробнее',
	registeredFor: 'Регистрации',
	noRegistration: 'Вы не регистрировались ни на одно событие',
	necessaryRegister: 'Необходимо быть зарегистрированным в системе',
	toEvent: 'Подробнее',
	youOrdered: 'История заказов',
	noOrder: 'Вы ещё не совершали заказов',
	finishRegistration: 'Пожалуйста, завершите регистрацию и оплатите заказ',
	continueRegistration: 'Продолжить регистрацию',
	buy: 'Оплатить',
	downloadBill: 'Скачать счет',
	openContract: 'Открыть договор',
	paidUp: 'Оплачено',
	validUntil: 'Действителен до',
	invoice: 'Счет',
	billDate: 'Дата выставления счета',
	recommendedActivities: 'Вас может заинтересовать',
	detailsAndRegistration: 'Детали и регистрация',
	moreDetails: 'Подробнее',
	myDocuments: 'Мои документы',
	goToAdmission: 'Подробнее',
	dragHere: 'Перетащите файл сюда',
	delete: 'Удалить',
	add: 'Добавить',
	value: 'Значение:',
	reference: 'Рекомендатель',
	fullName: 'Полное имя (ФИО)',
	enterValue: 'Введите значение',
	companyName: 'Название компании/организации',
	SchoolName: 'Школа',
	jobTitle: 'Позиция',
	phone: 'Телефон',
	addReference: 'Добавить рекомендателя',
	deleteReference: 'Удалить рекомендателя',
	document: 'Документ',
	nameOfDocument: 'Наименование документа',
	fillCorrectly: 'Заполните поле корректно',
	addDocument: 'Добавить документ',
	deleteDocument: 'Удалить документ',
	educationalInstitution: 'Название учебного заведения',
	selectValue: 'Выберите значение',
	majorField: 'Специальность/направление/форма обучения',
	startDate: 'Начало обучения',
	endDate: 'Окончание обучения',
	countryEdu: 'Страна обучения',
	cityEdu: 'Город обучения',
	addEdu: 'Добавить образование',
	deleteEdu: 'Удалить образование',
	learnedAbout: 'Как вы узнали о СКОЛКОВО?',
	alumniName: 'ФИО выпускника',
	language: 'Язык',
	proficiency: 'Уровень владения',
	chooseProficiency: 'Выберите уровень владения',
	addLanguage: 'Добавить язык',
	deleteLanguage: 'Удалить язык',
	enterProgrammingLanguage: 'Введите язык программирования',
	workplace: 'Место работы',
	field: 'Отрасль',
	corporateWeb: 'Сайт компании/организации',
	lastPosition: 'Должность',
	from: 'С даты',
	to: 'По дату',
	keyResponsibilities: 'Основные обязанности и результаты',
	addWorkplace: 'Добавить место работы',
	deleteWorkplace: 'Удалить место работы',
	jobResponsibilities: 'Укажите основные должностные обязанности (кратко). Количество знаков – 500',
	otherDocs: 'Другие документы',
	edit: 'Редактировать',
	replace: 'Заменить',
	docName: 'название документа',
	diploma: 'Диплом',
	noDiploma: 'Нет диплома',
	diplomaInfo: 'Если образование получено за рубежом, документы об образовании должны признаваться в РФ. В случае, если Ваш диплом не признается в РФ, для зачисления на программу потребуется прохождение процедуры признания иностранного образования.',
	numberDiploma: 'Номер диплома',
	scanDiploma: 'Скан диплома о высшем образовании',
	addDiploma: 'Добавить диплом',
	deleteDiploma: 'Удалить диплом',
	higherEdu: 'Есть ли высшее образование',
	passport: 'Паспорт',
	noPassport: 'Нет паспорта гражданина РФ',
	foreignPassport: 'Паспорт иностранного государства',
	passportCountry: 'Страна, выдавшая паспорт',
	passportNumber: 'Номер паспорта другой страны',
	enterNumber: 'Введите серию паспорта',
	noSnils: 'Нет СНИЛС',
	snilsNumber: 'Номер СНИЛС',
	snils: 'СНИЛС',
	seriesOfPassport: 'Серия паспорта',
	passportNumberRu: 'Номер паспорта',
	issuingAuth: 'Кем выдан паспорт',
	issueDate: 'Дата выдачи паспорта',
	issueCode: 'Номер подразделения',
	regAddress: 'Адрес регистрации',
	firstPage: 'Первый разворот',
	registrationPage: 'Страница с регистрацией',
	foreignPassportScan: 'Скан паспорта иностранного государства',
	enterPassportSeries: 'Введите серию паспорта',
	enterPassportNumber: 'Введите номер паспорта',
	chooseList: 'Выберите из списка предложенных значений',
	chooseListHint: 'Необходимо выбрать из списка предложенных значений или вписать свое',
	enterIssueDate: 'Введите дату выдачи паспорта',
	enterIssuingAuthority: 'Введите номер подразделения',
	otherSettings: 'Другие настройки',
	emailNotifications: 'Включить email уведомления',
	yourPhoto: 'Ваша фотография',
	chooseFile: 'Пожалуйста, выберите файл',
	passwordChange: 'Изменение пароля',
	upload: 'Загрузить',
	camera: 'Камера',
	errorUpload: 'Ошибка при загрузке изображения, попробуйте еще',
	fileSize: 'Размер файла не должен превышать 5 мб',
	specifyIndustry: 'Укажите, к какой индустрии относится компания, в которой вы работаете',
	newEconomy: 'Относится ли компания к одной из индустрий новой экономики',
	managementBudget: 'Бюджет в управлении',
	executiveService: 'Управленческий стаж',
	businessAmount: 'Оборот компании',
	entrepreneurialExperience: 'Предпринимательский стаж',
	subordinateEmployees: 'Количество сотрудников в подчинении',
	companyEmployees: 'Количество сотрудников в организации',
	doesntBelong: 'Не относится',
	admission: 'Адмиссия',
	goBackAdmission: 'Вернуться к адмиссии',
	required: 'Поле обязательно для заполнения',
	saveDraft: 'Сохранить черновик',
	underConsideration: 'Анкета на рассмотрении',
	declined: 'Анкета на рассмотрении',
	approved: 'Анкета одобрена',
	submitApplication: 'Отправить заявку на рассмотрение',
	refuseAdmission: 'Отказаться от адмиссии',
	sendQuestionnaire: 'Я полностью заполнил данные и готов отправить анкету на рассмотрение комиссии.',
	finalSubmit: 'Отправить финальную анкету можно только один раз',
	personGen: ' физических лиц',
	corporateEntities: 'юридических лиц',
	educationPrice: 'Стоимость обучения',
	diplomaNumber: 'Номер диплома',
	diplomaSeries: 'Серия диплома',
	DiplomaIssue: 'Дата выдачи диплома',
	graduationDate: 'Дата окончания обучения',
	trainingStart: 'Дата начала обучения',
	degree: 'Степень/Диплом',
	select: 'Выбрать',
	dateMask: 'ДД.ММ.ГГГГ',
	selectPosition: 'Укажите вашу роль в компании',
	enterPosition: 'Введите должность',
	toPresent: 'По настоящее время',
	career: 'Карьера в Школе',
	newFirst: 'Сначала новые',
	oldFirst: 'Сначала старые',
	donationsText: 'Поставьте галочку, если вы не против того, чтобы ваше имя отображалось на странице «Мы благодарим» в списке меценатов.',
	weThank: 'Мы благодарим',
	patronsList: 'в списке меценатов.',
	recoverHover: 'Нажмите @:forgotPassword для отправки ссылки восстановления на почту.',
	accessRecovery: 'Восстановление доступа',
	continue: 'Продолжить',
	return: 'Назад',
	bio: 'биографию',
	subscribeInProgress: 'Выполняется подписка',
	goToCanvas: 'Перейти в Canvas LMS',
	showMore: 'Показать еще',
	showAll: 'Показать всё',
	all: 'Все',
	video: 'Видео',
	podcast: 'Подкаст',
	noContent: 'Не нашлось контента. Возможно, вам будут интересны другие мероприятия и программы.',
	myProfile: 'Личный Кабинет',
	skip: 'Пропустить',
	next: 'Далее',
	back: 'Назад',
	finish: 'Завершить',
	loading: 'Загрузка',
	conditionsToGet: 'Условия получения',
	fieldRequired: 'Обязательное поле',
	signUp: 'Зарегистрироваться',
	activationMessage: 'Требуется активация.',
	sendLetterTo: 'Письмо отправлено на ',
	goToLK: 'Перейти в профиль',
	received: 'Получено',
	b2bAlumniInput: 'Учился на b2b программе',
};
